import { createApp } from "vue";

import App from "./App.vue";

import "@/assets/css/main.css";

import { bootApp } from "./core/boot-app";

export const app = createApp(App);

bootApp(app).then(() => app.mount("#app"));
